(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lensory-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('lensory-footer-signup')) return;

    // Klaviyo API revision, checked against developers.klaviyo.com on 2026-10-23.
    const KLAVIYO_REVISION = '2026-10-15';
    const CUSTOM_SOURCE = 'Footer signup';
    const REQUEST_TIMEOUT_MS = 15000;
    const EMAIL_PATTERN = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

    class LensoryFooterSignup extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('.lf-form');
        this.input = this.querySelector('.lf-input');
        this.button = this.querySelector('.lf-button');
        this.buttonLabel = this.querySelector('.lf-button__label');
        this.error = this.querySelector('.lf-error');
        this.success = this.querySelector('.lf-success');
        this.successTitle = this.querySelector('.lf-success__title');
        this.resetButton = this.querySelector('.lf-reset');
        if (!this.form || !this.input || !this.button) return;

        this.idleLabel = this.buttonLabel.textContent;
        this.describedBy = this.input.getAttribute('aria-describedby') || '';
        this.form.noValidate = true;

        this.listeners = new AbortController();
        const { signal } = this.listeners;
        this.form.addEventListener('submit', (event) => this.handleSubmit(event), { signal });
        this.input.addEventListener('input', () => this.clearError(), { signal });
        this.resetButton?.addEventListener('click', () => this.reset(), { signal });

        if (!this.isConfigured) {
          console.warn(
            '[Lensory footer] Klaviyo public key or list ID is blank, so the signup form is off. Add both in the section settings.'
          );
        }
      }

      disconnectedCallback() {
        this.listeners?.abort();
      }

      get isConfigured() {
        return Boolean(this.dataset.publicKey && this.dataset.listId);
      }

      async handleSubmit(event) {
        event.preventDefault();
        if (this.busy) return;

        const email = this.input.value.trim();
        if (!EMAIL_PATTERN.test(email)) {
          this.showError(this.dataset.errorInvalid);
          return;
        }

        if (!this.isConfigured) {
          console.warn('[Lensory footer] Signup skipped: Klaviyo public key or list ID is blank.');
          this.showError(this.dataset.errorGeneric);
          return;
        }

        this.clearError();
        this.setLoading(true);
        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(this.dataset.publicKey)}`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/vnd.api+json',
                revision: KLAVIYO_REVISION,
              },
              body: JSON.stringify(this.buildPayload(email)),
              signal: AbortSignal.timeout ? AbortSignal.timeout(REQUEST_TIMEOUT_MS) : undefined,
            }
          );
          if (response.status !== 202) throw new Error(`Klaviyo responded with ${response.status}`);
          this.showSuccess();
        } catch (error) {
          console.warn('[Lensory footer] Signup failed:', error);
          this.showError(this.dataset.errorGeneric);
        } finally {
          this.setLoading(false);
        }
      }

      buildPayload(email) {
        return {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: CUSTOM_SOURCE,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                  },
                },
              },
            },
            relationships: {
              list: { data: { type: 'list', id: this.dataset.listId } },
            },
          },
        };
      }

      setLoading(isLoading) {
        this.busy = isLoading;
        this.button.disabled = isLoading;
        this.buttonLabel.textContent = isLoading ? this.dataset.loadingLabel || this.idleLabel : this.idleLabel;
        this.form.toggleAttribute('aria-busy', isLoading);
      }

      showError(message) {
        this.error.textContent = message || '';
        this.input.setAttribute('aria-invalid', 'true');
        this.input.setAttribute('aria-describedby', `${this.error.id} ${this.describedBy}`.trim());
        this.input.focus();
      }

      clearError() {
        if (!this.input.hasAttribute('aria-invalid')) return;
        this.error.textContent = '';
        this.input.removeAttribute('aria-invalid');
        if (this.describedBy) {
          this.input.setAttribute('aria-describedby', this.describedBy);
        } else {
          this.input.removeAttribute('aria-describedby');
        }
      }

      showSuccess() {
        this.form.hidden = true;
        this.success.hidden = false;
        this.successTitle?.focus();
      }

      reset() {
        this.form.reset();
        this.clearError();
        this.success.hidden = true;
        this.form.hidden = false;
        this.input.focus();
      }
    }

    customElements.define('lensory-footer-signup', LensoryFooterSignup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
